export const getFilteredStatus = (activeFilters: string[], subscriptions) => {
  const filteredSubscriptions = subscriptions.filter((subscription) =>
    activeFilters.includes(subscription?.health?.status),
  );
  return filteredSubscriptions;
};
